import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { IonItem, IonLabel, IonSelect, IonSelectOption, SelectCustomEvent } from "@ionic/vue";
import { computed } from "vue";
import { useField } from "vee-validate";
import { t } from "@/plugins/vue-i18n";

import { getOptions } from "@/functions/converter";

import { SelectBaseProps } from "@/types/props";
import { SelectBaseEmits } from "@/types/emits";
import { ION_MODE, ION_SELECT_INTERFACE, LABEL_POSITION } from "@/types/enum/ionicEnum";
import { SelectOption } from "@/types/others";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectBase',
  props: {
    cancelText: { default: t('button.cancel') ?? 'Abbrechen' },
    compareWith: {},
    disabled: { type: Boolean },
    interface: { default: ION_SELECT_INTERFACE.ACTION_SHEET },
    interfaceOptions: { default: () => {
        return { mode: ION_MODE.IOS }
    } },
    mode: {},
    modelValue: {},
    multiple: { type: Boolean },
    name: {},
    okText: { default: t('button.ok') ?? 'Ok' },
    options: {},
    placeholder: { default: 'Auswählen' },
    selectedText: {},
    validateOption: {},
    valueKey: { default: 'value' },
    textKey: { type: [String, Function], default: 'text' },
    position: { default: LABEL_POSITION.STACKED },
    lines: { default: 'none' },
    selectClass: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// Vee-Validate Composable
const {
    name,
    errors,
    handleChange,
    handleBlur,
    validate
} = useField(
    props.validateOption?.name ?? '',
    props.validateOption?.rules ?? '',
    {
        valueProp: props.modelValue,
        initialValue: JSON.parse(JSON.stringify(props.modelValue ?? '')),
        label: props.validateOption?.label ?? props.validateOption?.name,
        ...props.validateOption?.options
    }
)

const parsedOptions = computed<SelectOption[]>(() => {
    if (!props.options) return []
    const textKey = props.textKey
    const valueKey = props.valueKey
    return getOptions(props.options, valueKey, textKey)
})

const handlerChange = (event: SelectCustomEvent): void => {
    emit('update:modelValue', event.detail.value);
    handleChange(event);
    emit('change', event.detail.value)
}

window.addEventListener('change-language', () => validate({ mode: 'force' }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    lines: __props.lines,
    class: "input-simple-container"
  }, {
    default: _withCtx(() => [
      (_unref(name) || _ctx.$slots.default)
        ? (_openBlock(), _createBlock(_unref(IonLabel), {
            key: 0,
            position: __props.position
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(_unref(name)), 1)
              ])
            ]),
            _: 3
          }, 8, ["position"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonSelect), {
        class: "select-base",
        "cancel-text": __props.cancelText,
        compareWith: __props.compareWith,
        disabled: __props.disabled,
        interface: __props.interface,
        "interface-options": __props.interfaceOptions,
        mode: __props.mode,
        multiple: __props.multiple,
        name: _unref(name),
        "ok-text": __props.okText,
        placeholder: __props.placeholder,
        "selected-text": __props.selectedText,
        value: __props.modelValue,
        onIonChange: handlerChange,
        onIonBlur: _unref(handleBlur)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "options", {}, () => [
            (parsedOptions.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(parsedOptions.value, (option) => {
                  return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                    key: option.value,
                    value: option.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 3
      }, 8, ["cancel-text", "compareWith", "disabled", "interface", "interface-options", "mode", "multiple", "name", "ok-text", "placeholder", "selected-text", "value", "onIonBlur"]),
      (_unref(errors) && _unref(errors).length > 0)
        ? (_openBlock(), _createBlock(_unref(IonLabel), {
            key: 1,
            slot: "error",
            class: "base-input-error"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (error) => {
                return (_openBlock(), _createElementBlock("span", { key: error }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.$slots['helper'])
        ? (_openBlock(), _createBlock(_unref(IonLabel), {
            key: 2,
            slot: "helper"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "helper")
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["lines"]))
}
}

})